/**
 * Connected Option Availability
 * Marks variant option buttons (size, color, etc.) as unavailable
 * based on the currently selected combination of options.
 */
(function() {
  var style = document.createElement('style');
  style.textContent = '.m-product-option--node__unavailable .m-product-option--node__label[data-option-type="button"]::before{background:linear-gradient(to bottom right,transparent calc(50% - 1.5px),#aaa calc(50% - .5px),#aaa calc(50% + .5px),transparent calc(50% + 1.5px)) no-repeat!important}';
  document.head.appendChild(style);

  function getProductVariants() {
    var scripts = document.querySelectorAll('script[type="application/json"]');
    for (var i = 0; i < scripts.length; i++) {
      try {
        var data = JSON.parse(scripts[i].textContent);
        if (Array.isArray(data) && data.length > 0 && data[0].option1 !== undefined && data[0].available !== undefined) {
          return data;
        }
      } catch(e) {}
    }
    return null;
  }

  function updateOptionAvailability() {
    var variants = getProductVariants();
    if (!variants) return;

    var picker = document.querySelector('variant-picker');
    if (!picker) return;

    var checkedInputs = picker.querySelectorAll('input[type="radio"]:checked');
    var selectedByIndex = {};
    checkedInputs.forEach(function(input) {
      var match = input.name.trim().match(/-(\d+)$/);
      if (match) selectedByIndex[parseInt(match[1])] = input.value;
    });

    var allInputs = picker.querySelectorAll('.m-product-option--node input[type="radio"]');
    allInputs.forEach(function(input) {
      var match = input.name.trim().match(/-(\d+)$/);
      if (!match) return;

      var thisIndex = parseInt(match[1]);
      var thisValue = input.value;

      var isAvailable = variants.some(function(variant) {
        if (variant['option' + thisIndex] !== thisValue) return false;
        if (!variant.available) return false;
        for (var idx in selectedByIndex) {
          if (parseInt(idx) === thisIndex) continue;
          if (variant['option' + idx] !== selectedByIndex[idx]) return false;
        }
        return true;
      });

      var node = input.closest('.m-product-option--node');
      if (!node) return;

      if (isAvailable) {
        node.classList.remove('m-product-option--node__unavailable');
        input.classList.remove('disabled');
      } else {
        node.classList.add('m-product-option--node__unavailable');
        input.classList.add('disabled');
      }
    });
  }

  /* Debounced version that waits for DOM to settle */
  var debounceTimer = null;
  function debouncedUpdate() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(updateOptionAvailability, 80);
  }

  /* After any option change, re-apply multiple times to survive theme re-renders */
  function scheduleUpdates() {
    [100, 300, 600, 1000, 1500].forEach(function(ms) {
      setTimeout(updateOptionAvailability, ms);
    });
  }

  /* Listen for option changes */
  document.addEventListener('change', function(e) {
    if (e.target.closest && e.target.closest('variant-picker')) {
      scheduleUpdates();
    }
  });

  /* Observe the entire document body for variant picker DOM swaps */
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (target.closest && (target.closest('variant-picker') || target.closest('.m-product-info'))) {
        debouncedUpdate();
        return;
      }
      /* Check if added nodes contain variant picker content */
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1 && (added[j].matches && added[j].matches('.m-product-option--node, variant-picker, [class*="product-option"]') || added[j].querySelector && added[j].querySelector('.m-product-option--node'))) {
          debouncedUpdate();
          return;
        }
      }
    }
  });

  function init() {
    observer.observe(document.body, { childList: true, subtree: true });
    updateOptionAvailability();
    /* Also run a few times on load in case of late rendering */
    setTimeout(updateOptionAvailability, 500);
    setTimeout(updateOptionAvailability, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
